import type { JiraBoard } from '../../types';

export const isJiraBoard = (entity: any): entity is JiraBoard => entity.__typename === 'JiraBoard';

export const getJiraBoardLink = (board: JiraBoard): string | null =>
	board?.boardFrontendUrl ?? null;
